import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M4.5 8.25V4.5C4.5 3.1191 5.6191 2 7 2h10c1.3809 0 2.5 1.1191 2.5 2.5v3.75H17V5.0898c0-.3086-.2812-.5898-.625-.5898s-.625.2813-.625.5898V8.25zM17 9.5v6.875c0 .3438-.2812.625-.625.625s-.625-.2812-.625-.625V9.5H4.5v11.25c0 .6902.5598 1.25 1.25 1.25h12.5c.6902 0 1.25-.5598 1.25-1.25V9.5z" /></g>,<defs key="1"></defs>,]
, 'AppliancesRefrigeratorx');
